var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694.923 62.6228C655.87 23.5705 592.553 23.5703 553.5 62.6228L81.581 534.543C67.621 548.503 58.1054 566.283 54.2337 585.64L34.6647 683.487C25.3351 730.133 66.463 771.263 113.111 761.933L210.956 742.363C230.315 738.493 248.095 728.977 262.055 715.017L733.973 243.096C773.026 204.044 773.026 140.728 733.973 101.675L694.923 62.6228ZM600.64 109.763C613.66 96.7458 634.763 96.7458 647.783 109.763L686.833 148.816C699.853 161.833 699.853 182.938 686.833 195.956L597.78 285.009L511.59 198.816L600.64 109.763ZM464.446 245.957L128.721 581.683C124.068 586.337 120.896 592.263 119.606 598.717L100.037 696.56L197.881 676.99C204.334 675.7 210.261 672.53 214.914 667.877L550.64 332.149L464.446 245.957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico_edit.545736dc2010d531e4c9c9bea2e32c7d.svg";
export { ForwardRef as ReactComponent };